import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from 'react'
import './custom.css';
import PaymentReport from "./components/Pages/Report/PaymentReport";
import BankStatementReport from "./components/Pages/Report/BankStatementReport";
import AppliedJobs from "./components/Pages/Report/AppliedJobs";
import AcceptedUsers from "./components/Pages/Report/AcceptedUsers";
import CompletedJobs from "./components/Pages/Report/CompletedJobs";
import IncompletedJobs from "./components/Pages/Report/IncompletedJobs";
import ReachedLocation from "./components/Pages/Report/ReachedLocation";
import PaymentApproved from "./components/Pages/Report/PaymentApproved";
import ConfirmPaymentTransferReport from "./components/Pages/Report/ConfirmPaymentTransferReport";
const Layout = lazy(() => import("./components/Layout/Layout"));
const Dashboard = lazy(() => import("./components/Pages/Dashboard/Dashboard"));
const JobDashboard = lazy(() => import("./components/Pages/Dashboard/JobDashboard"));
const Login = lazy(() => import('./components/Pages/Login/Login'));
const ApprovePayout = lazy(() => import("./components/Pages/Operation/ApprovePayout"));
const BankVerification = lazy(() => import("./components/Pages/Operation/BankVerification"));
const IncompleteRegistration = lazy(() => import("./components/Pages/Operation/IncompleteRegistration"));
const PostWorkRequirement = lazy(() => import("./components/Pages/Operation/PostWorkRequirement"));
const ReachLocation = lazy(() => import("./components/Pages/Operation/ReachLocation"));
const UpdateDutyHours = lazy(() => import("./components/Pages/Operation/UpdateDutyHours"));
const ChangePassword = lazy(() => import("./components/Pages/User&Permission/ChangePassword"));
const GroupMaster = lazy(() => import("./components/Pages/User&Permission/GroupMaster"));
const ResetPassword = lazy(() => import("./components/Pages/User&Permission/ResetPassword"));
const UserLogReport = lazy(() => import("./components/Pages/User&Permission/UserLogReport"));
const UserMaster = lazy(() => import("./components/Pages/User&Permission/UserMaster"));
const UserMenuAccess = lazy(() => import("./components/Pages/User&Permission/UserMenuAccess"));
const Error404 = lazy(() => import("./components/Common/Error404"));
const GroupMenuAccess = lazy(() => import("./components/Pages/User&Permission/GroupMenuAccess"));
const AcceptWorkRequest = lazy(() => import("./components/Pages/Operation/AcceptWorkRequest"));
const BranchMaster = lazy(() => import("./components/Pages/Master/BranchMaster"));
const WorkTypeMaster = lazy(() => import("./components/Pages/Master/WorkTypeMaster"));
const ConfirmPaymentTransfer = lazy(() => import("./components/Pages/Operation/ConfirmPaymentTransfer"));
const UserDispute = lazy(() => import("./components/Pages/Operation/UserDispute"));
const LedgerViewReport = lazy(() => import("./components/Pages/Report/LedgerViewReport"));
const JobStatusReport = lazy(() => import("./components/Pages/Report/JobStatusReport"));
const UserBranchAccess = lazy(() => import("./components/Pages/Master/UserBranchAccess"));


const App = () => {
    return (
        <Suspense>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Error404 />} />
                <Route element={<Layout />}>
                    <Route path="*" element={<Error404 />} />
                    <Route path="Dashboard/Dashboard" element={<Dashboard />} />
                    <Route path="Dashboard/JobDashboard" element={<JobDashboard />} />

                    {/*..........Operation..........*/}
                    <Route path="/Operation/IncompleteRegistration" element={<IncompleteRegistration />} />
                    <Route path="/Operation/BankVerification" element={<BankVerification />} />
                    <Route path="/Operation/PostWorkRequirement" element={<PostWorkRequirement />} />
                    <Route path="/Operation/AcceptWorkRequest" element={<AcceptWorkRequest />} />
                    <Route path="/Operation/ReachLocation" element={<ReachLocation />} />
                    <Route path="/Operation/UpdateDutyHours" element={<UpdateDutyHours />} />
                    <Route path="/Operation/ApprovePayout" element={<ApprovePayout />} />
                    <Route path="/Operation/ConfirmPaymentTransfer" element={<ConfirmPaymentTransfer />} />                   
                    <Route path="/Operation/UserDispute" element={<UserDispute />} />                   

                    {/*..........User And Permission..........*/}
                    <Route path="/UserPermission/ChangePassword" element={<ChangePassword />} />
                    <Route path="/UserPermission/ResetPassword" element={<ResetPassword />} />
                    <Route path="/UserPermission/UserLogReport" element={<UserLogReport />} />
                    <Route path="/UserPermission/UserMaster" element={<UserMaster />} />
                    <Route path="/UserPermission/GroupMaster" element={<GroupMaster />} />
                    <Route path="/UserPermission/GroupMenuAccess" element={<GroupMenuAccess />} />
                    <Route path="/UserPermission/UserMenuAccess" element={<UserMenuAccess />} />

                    {/*..........Master..........*/}
                    <Route path="/Master/BranchMaster" element={<BranchMaster />} />
                    <Route path="/Master/WorkTypeMaster" element={<WorkTypeMaster />} />
                    <Route path="/Master/UserBranchAccess" element={<UserBranchAccess />} />

                    {/*..........Report..........*/}
                    <Route path="/Report/LedgerViewReport" element={<LedgerViewReport />} />
                    <Route path="/Report/JobStatusReport" element={<JobStatusReport />} />
                    <Route path="/Report/PaymentReport" element={<PaymentReport />} />
                    <Route path="/Report/BankStatementReport" element={<BankStatementReport />} />
                    <Route path="/Report/AppliedJobs" element={<AppliedJobs />} />
                    <Route path="/Report/AcceptedUsers" element={<AcceptedUsers />} />
                    <Route path="/Report/CompletedJobs" element={<CompletedJobs />} />
                    <Route path="/Report/IncompletedJobs" element={<IncompletedJobs />} />
                    <Route path="/Report/ReachedLocation" element={<ReachedLocation />} />
                    <Route path="/Report/PaymentApproved" element={<PaymentApproved />} />
                    <Route path="/Report/ConfirmPaymentTransferReport" element={<ConfirmPaymentTransferReport />} />
                </Route>
            </Routes>
        </Suspense>
    )
}

export default App;

